<template>
  <el-row>
    <el-col>
      <el-card
        v-loading="isLoading"
        shadow="never"
      >
        user profile page
      </el-card>
    </el-col>
  </el-row>
</template>

<script>

export default {

}
</script>

<style>

</style>
